import { UpdateReleaseArgs } from "../../../api/releases/releaseAPI";
import {
  SupplyChainGenre,
  SupplyChainLanguage,
  SupplyChainParentalAdvisory,
} from "../../../api/supplyChain/supplyChainModels";
import { NewReleaseFormState } from "../../../atoms/forms/newReleaseFormAtom";
import { Release } from "../../../store/models/release";

export enum ReleaseFormVariant {
  FULLSCREEN = "fullscreen",
  SIDEPANEL = "sidepanel",
}

export const handleUpdateReleaseForm = async (
  releaseForm: NewReleaseFormState,
  updateRelease: (args: UpdateReleaseArgs) => Promise<Release>,
) => {
  const args: UpdateReleaseArgs = {
    release_type: parseInt(releaseForm.releaseType),
    supply_chain_main_genre: parseInt(releaseForm.genre),
    supply_chain_secondary_genre: parseInt(releaseForm.secondaryGenre),
    artist_display_name: releaseForm.artistName,
    title: releaseForm.albumTitle,
    supply_chain_language: parseInt(releaseForm.language),
    parental_advisory: parseInt(releaseForm.parentalAdvisory),
    published_at: releaseForm.publishDate,
    published_end: releaseForm.publishedEndDate,
    description: releaseForm.albumDescription,
    featured: releaseForm.featured,
  };
  return updateRelease(args);
};

/**
 * Converts a list of Supply Chain options into a map of id to name.
 * @example
 * ```typescript
 * const languages = [
 *   { id: 1, name: "English" },
 *   { id: 2, name: "Spanish" },
 * ];
 * const convertedLanguages = convertSupplyChainOptions(languages);
 * // returns { 1: "English", 2: "Spanish" }
 * ```
 */
export const convertSupplyChainOptions = (
  options: SupplyChainLanguage[] | SupplyChainGenre[],
) =>
  options.reduce(
    (acc, option) => {
      acc[option.id] = option.name;
      return acc;
    },
    {} as Record<number, string>,
  );

export const convertSupplyChainParentalAdvisoryOptions = (
  options: SupplyChainParentalAdvisory[],
) =>
  options.reduce(
    (acc, option) => {
      acc[option.id] = option.title;
      return acc;
    },
    {} as Record<number, string>,
  );
